@let jobSkillsSummaryValue = jobSkillsSummary();
@let showJobTitleValue = showJobTitle();
@let showPositionButtonValue = showPositionButton();
@let themeValue = theme();
@let candidateIdValue = candidateId();

<rt-box variant="default vertical no-padding">
  <rt-job-skills-summary-details-header
    [job]="jobSkillsSummaryValue.job"
    [interviewResultsCount]="jobSkillsSummaryValue.interviewResultsCount"
    [users]="jobSkillsSummaryValue.users"
    [showJobTitle]="showJobTitleValue"
    [showPositionButton]="showPositionButtonValue"
    (viewPosition)="onViewPosition()"
    padding-top
    padding-lr
  />
  <rt-job-skills-summary-details-chart-section
    [summaryBasicInfo]="jobSkillsSummaryValue.summary"
    [isHidden]="jobSkillsSummaryValue.isHidden"
    [theme]="themeValue"
    [attr.padding-bottom]="!jobSkillsSummaryValue.skillsDetails?.length || null"
    padding-lr
  />
  @if (jobSkillsSummaryValue.skillsDetails?.length) {
    <rt-job-skills-summary-details-skills-section
      [jobSkillsDetails]="jobSkillsSummaryValue.skillsDetails!"
      [jobId]="jobSkillsSummaryValue.job!.id"
      [candidateId]="candidateIdValue"
      padding-lr
    />
  }
</rt-box>
